import { NitroModules } from "react-native-nitro-modules";
import { rethrowNativeError } from "../nativeError";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneLocalAuthentication");
  return hybrid;
}
function canEvaluatePolicy() {
  try {
    return native().canEvaluatePolicy();
  } catch (error) {
    return rethrowNativeError(error);
  }
}
function evaluatePolicy(reason) {
  return native().evaluatePolicy(reason).catch(rethrowNativeError);
}
var LocalAuthentication = Object.freeze({
  canEvaluatePolicy,
  evaluatePolicy
});
export {
  LocalAuthentication
};
//# sourceMappingURL=index.native.js.map
